"use client";

import { createContext, useContext } from "react";

/* Lets genre tags filter the city feed in place. Cards elsewhere link to
   genre calendars, falling back to ?genre= for unmapped tags. */
export interface FeedGenreFilter {
  selectedGenres: string[];
  /** Filter the feed down to just this genre; picking the sole active genre
      again clears the filter. */
  selectGenre: (genre: string) => void;
}

const FeedGenreFilterContext = createContext<FeedGenreFilter | null>(null);
const GenreTagLinkModeContext = createContext<"calendar" | "directory">("calendar");

export const FeedGenreFilterProvider = FeedGenreFilterContext.Provider;
export const GenreTagLinkModeProvider = GenreTagLinkModeContext.Provider;
export function useGenreTagLinkMode() {
  return useContext(GenreTagLinkModeContext);
}

export function useFeedGenreFilter(): FeedGenreFilter | null {
  return useContext(FeedGenreFilterContext);
}
